module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-green.3cc1592.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-green.svg
// module id = d6Af
// module chunks = 82